// FUNÇÕES/MÓDULOS SITE
import changeLang from './modules/changeLang';
import search from './modules/search';
import  zoomImages  from './modules/zoom_images';
import contactForm from './modules/contactForm';
import anchorLinks from './modules/anchor_links';
//import hoverBackgroundGradient from './modules/hover_bg-gradient';
import shareLink from './modules/shareLink';
import headerHome from './modules/component_header';
import addMorePosts from './modules/addMorePosts';
import animation from './modules/animation'
import footer from './modules/footer';
import headers from './modules/header';

footer()
addMorePosts();
changeLang();
search();
zoomImages();
contactForm()
shareLink();
headerHome()
animation()
headers()
anchorLinks()
// hoverBackgroundGradient()

function removeImageDetails(){
    const href = window.location.href
    if(href.includes("/blog")){
        document.querySelector(".image--details-footer").style.display = 'none'
    }
}
removeImageDetails()



    
